import { useQuery } from '@tanstack/react-query';
import { useDebounce } from 'use-debounce';
import { priceOptions } from '../../constants/prices';
import { haveSameParkingProperties } from '../../utils/haveSameParkingProperties';
const DEBOUNCE_MS = 500;
export function usePriceDebounced(parkingId, parkTimeContract, spotId, properties) {
    const [debouncedParkingId] = useDebounce(parkingId, DEBOUNCE_MS, { leading: false, trailing: true });
    const [debouncedParkTimeContract] = useDebounce(parkTimeContract, DEBOUNCE_MS, { leading: false, trailing: true });
    const [debouncedSpotId] = useDebounce(spotId, DEBOUNCE_MS, { leading: false, trailing: true });
    const [debouncedProperties] = useDebounce(properties, DEBOUNCE_MS, {
        leading: false,
        trailing: true,
        equalityFn: haveSameParkingProperties,
    });
    const debouncing = debouncedParkingId !== parkingId ||
        debouncedParkTimeContract !== parkTimeContract ||
        debouncedSpotId !== spotId ||
        !haveSameParkingProperties(debouncedProperties, properties);
    const { data, isLoading, isSuccess, isError } = useQuery({
        ...priceOptions.get({
            parkingId: debouncedParkingId,
            parkTimeContract: debouncedParkTimeContract,
            spotId: debouncedSpotId,
            properties: debouncedProperties,
        }),
        enabled: !!debouncedParkingId,
    });
    return {
        price: data?.[0],
        loadingPrice: (isLoading || debouncing) && !isError,
        isSuccess,
        isError,
    };
}
